export default {"src":"/_next/static/media/instagram-logo-hover.020266d5.svg","height":60,"width":60,"blurWidth":0,"blurHeight":0};